import ProductImage from "./ProductImage";
import getFallbackImage from "./getFallbackImage";

export { getFallbackImage };
export default ProductImage;
